import React from 'react';
import styles from './LoadingSection.module.css';

type LoadingSectionProps = {
  width?: number;
  height?: number | string;
};

const LoadingSection: React.FunctionComponent<LoadingSectionProps> = ({ width, height }) => (
  <span className={styles.loadingSection} style={{ width, height }} />
);

export default LoadingSection;

LoadingSection.defaultProps = {
  width: 50,
  height: 'inherit',
};
